import { useState } from 'react';

import { Box } from '@mui/material';

import { ActivityFeed } from '@modules/_shared/components/feed-v2/ActivityFeed';
import { useScrollableAncestor } from '@modules/_shared/components/feed-v2/useScrollableAncestor';
import { DASHBOARD_FEED } from '@modules/dashboard/dashboardQueries';

export const DashboardFeed = () => {
  const [anchor, setAnchor] = useState<HTMLDivElement | null>(null);
  const scrollParent = useScrollableAncestor(anchor);

  return (
    <Box ref={setAnchor}>
      <ActivityFeed
        query={DASHBOARD_FEED}
        variables={{}}
        paginate
        showFilters={false}
        scrollParent={scrollParent}
      />
    </Box>
  );
};
